import React, { useState, useEffect } from 'react';
import LanguageSelector from '../ui/LanguageSelector';
import ShopifyIcon from '../ui/ShopifyIcon';
import useLanguage from '../../hooks/useLanguage';
import { SHOPIFY_STORE_URL } from '../../utils/constants';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { renderKey, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY >= 75);
    };

    handleScroll(); // Check initial state
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { nameKey: 'nav.services', href: '#servicios' },
    { nameKey: 'nav.process', href: '#proceso' },
    { nameKey: 'nav.cases', href: '#casos-exito' },
    { nameKey: 'nav.testimonials', href: '#testimonios' },
    { nameKey: 'nav.faq', href: '#faq' },
    { nameKey: 'nav.contact', href: '#contacto' }
  ];

  const shopUrl = SHOPIFY_STORE_URL;

  return (
    <header key={renderKey} className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
          <div className="nav-brand">
            <a
              href="/"
              className="brand-logo"
              aria-label={`CodevNext — ${t('nav.tagline')}`}
            >
              <span className="brand-logo-stack">
                <img
                  src="/codevnext-logo.png"
                  alt=""
                  className="brand-logo-img"
                  width={220}
                  height={56}
                  decoding="async"
                />
                <span className="brand-tagline">{t('nav.tagline')}</span>
              </span>
            </a>
          </div>

          <div className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`} aria-hidden={!isMobileMenuOpen}>
            <ul className="nav-list">
              {navItems.map((item, index) => (
                <li key={index} className="nav-item">
                  <a 
                    href={item.href} 
                    className="nav-link"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {t(item.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
            
            <div className="nav-actions">
              <LanguageSelector />
              <a
                href={shopUrl}
                className="btn btn-shopify-nav"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('nav.shopAria')}
              >
                <ShopifyIcon size={18} />
                <span>{t('nav.shop')}</span>
              </a>
              <a href="#contacto" className="btn btn-primary" aria-label={t('nav.bookCall')}>
                {t('nav.bookCall')}
              </a>
            </div>
          </div>

          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'mobile-menu-toggle-open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
            aria-expanded={isMobileMenuOpen}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
